tinymce.addI18n("az", {
    "#": "#",
    "Accessibility": "\u018fl\xe7atanl\u0131q",
    "Accordion": "Akkordion",
    "Accordion body...": "Akkordion m\u0259tni...",
    "Accordion summary...": "Akkordion \u015f\u0259rhi...",
    "Action": "\u018fmr",
    "Activity": "F\u0259aliyy\u0259t",
    "Address": "Adres",
    "Advanced": "Geni\u015fl\u0259nmi\u015f",
    "Align": "D\xfczl\u0259ndir",
    "Align center": "M\u0259rk\u0259z \xfczr\u0259",
    "Align left": "Sol t\u0259r\u0259f \xfczr\u0259",
    "Align right": "Sa\u011f t\u0259r\u0259f \xfczr\u0259",
    "Alignment": "D\xfczl\u0259ndirm\u0259",
    "Alignment {0}": "Yerl\u0259\u015fdirm\u0259 {0}",
    "All": "Ham\u0131s\u0131",
    "Alternative description": "Alternativ t\u0259svir",
    "Alternative source": "Alternativ m\u0259nb\u0259",
    "Alternative source URL": "Alternativ m\u0259nb\u0259 URL-i",
    "Anchor": "L\xf6vb\u0259r",
    "Anchor...": "Anchor",
    "Anchors": "L\xf6vb\u0259rl\u0259r",
    "Animals and Nature": "Heyvanlar v\u0259 t\u0259bi\u0259t",
    "Arrows": "Oxlar",
    "B": "B",
    "Background color": "Arxafon r\u0259ngi",
    "Background color {0}": "Arxa plan r\u0259ngi {0}",
    "Black": "Qara",
    "Block": "Blokla",
    "Block {0}": "Blok {0}",
    "Blockquote": "Sitat",
    "Blocks": "Bloklar",
    "Blue": "Mavi",
    "Blue component": "G\xf6y komponent",
    "Body": "K\xfctl\u0259",
    "Bold": "Qal\u0131n",
    "Border": "\xc7\u0259r\xe7iv\u0259",
    "Border color": "\xc7\u0259r\xe7iv\u0259 r\u0259ngi",
    "Border style": "K\u0259narl\u0131q stili",
    "Border width": "K\u0259narl\u0131q geni\u015fliyi",
    "Bottom": "A\u015fa\u011f\u0131",
    "Browse files": "Fayllar\u0131 g\xf6zd\u0259n ke\xe7ir",
    "Browse for an image": "\u015e\u0259kil se\xe7",
    "Browse links": "Linkl\u0259ri g\xf6zd\u0259n g\xf6zd\u0259n ke\xe7ir",
    "Bullet list": "G\xfcll\u0259 siyah\u0131",
    "Cancel": "L\u0259\u011fv et",
    "Caption": "Ba\u015flan\u011f\u0131c",
    "Cell": "H\xfccr\u0259",
    "Cell padding": "H\xfccr\u0259l\u0259rin sah\u0259l\u0259ri",
    "Cell properties": "H\xfccr\u0259nin x\xfcsusiyy\u0259tl\u0259ri",
    "Cell spacing": "H\xfccr\u0259l\u0259rin aras\u0131nda m\u0259saf\u0259",
    "Cell styles": "Xana still\u0259ri",
    "Cell type": "H\xfccr\u0259nin tipi",
    "Center": "M\u0259rk\u0259z \xfczr\u0259",
    "Characters": "Simvollar",
    "Characters (no spaces)": "Simvollar (bo\u015fluqsuz)",
    "Circle": "Dair\u0259",
    "Class": "Sinif",
    "Clear formatting": "Format\u0131 t\u0259mizl\u0259",
    "Close": "Ba\u011fla",
    "Code": "Kod",
    "Code sample...": "Kod n\xfcmun\u0259si",
    "Code view": "Kod g\xf6r\xfcn\xfc\u015f\xfc",
    "Color Picker": "R\u0259ng se\xe7ici",
    "Color swatch": "R\u0259ng n\xfcmun\u0259si",
    "Cols": "S\xfctunlar",
    "Column": "S\xfctun",
    "Column clipboard actions": "S\xfctun m\xfcbadil\u0259 buferi h\u0259r\u0259k\u0259tl\u0259ri",
    "Column group": "S\xfctunun qrupu",
    "Column header": "S\xfctun ba\u015fl\u0131\u011f\u0131",
    "Constrain proportions": "Nisb\u0259tl\u0259rin saxlan\u0131lmas\u0131",
    "Copy": "K\xf6\xe7\xfcr",
    "Copy column": "S\xfctunu kopyala",
    "Copy row": "S\u0259tiri k\xf6\xe7\xfcr",
    "Could not find the specified string.": "G\xf6st\u0259ril\u0259n s\u0259tiri tapmaq olmur",
    "Could not load emojis": "Emoji y\xfckl\u0259m\u0259k m\xfcmk\xfcn olmad\u0131",
    "Count": "Say",
    "Currency": "Valyuta",
    "Current window": "Cari p\u0259nc\u0259r\u0259",
    "Custom color": "\xc7\u0259kilm\u0259 r\u0259ng",
    "Custom...": "\xc7\u0259kilm\u0259...",
    "Cut": "K\u0259s",
    "Cut column": "S\xfctunu k\u0259s",
    "Cut row": "S\u0259tiri k\u0259s",
    "Dark Blue": "T\xfcnd g\xf6y",
    "Dark Gray": "T\xfcnd boz",
    "Dark Green": "T\xfcnd ya\u015f\u0131l",
    "Dark Orange": "T\xfcnd nar\u0131nc\u0131",
    "Dark Purple": "T\xfcnd b\u0259n\xf6v\u015f\u0259yi",
    "Dark Red": "T\xfcnd q\u0131rm\u0131z\u0131",
    "Dark Turquoise": "T\xfcnd firuz\u0259yi",
    "Dark Yellow": "T\xfcnd sar\u0131",
    "Dashed": "S\u0131n\u0131q x\u0259tli",
    "Date/time": "Tarix/saat",
    "Decrease indent": "Bo\u015flu\u011fu azalt",
    "Default": "Susmaya g\xf6r\u0259",
    "Delete accordion": "Akkordionu silin",
    "Delete column": "S\xfctunu sil",
    "Delete row": "S\u0259tri sil",
    "Delete table": "C\u0259dv\u0259li sil",
    "Dimensions": "\xd6l\xe7\xfcl\u0259r",
    "Disc": "Disk",
    "Div": "Div",
    "Document": "S\u0259n\u0259d",
    "Dotted": "N\xf6qt\u0259li",
    "Double": "\u0130kiqat",
    "Drop an image here": "\u015e\u0259kli buraya s\xfcr\xfckl\u0259yin",
    "Dropped file type is not supported": "Se\xe7ilmi\u015f fayl n\xf6v\xfc d\u0259st\u0259kl\u0259nmir",
    "Edit": "Redakt\u0259 et",
    "Embed": "\u018flav\u0259 etm\u0259k \xfc\xe7\xfcn kod",
    "Emojis": "Emoji",
    "Emojis...": "Emojil\u0259r...",
    "Error": "X\u0259ta",
    "Error: Form submit field collision.": "X\u0259ta: Forma g\xf6nd\u0259rm\u0259 sah\u0259sind\u0259 toqqu\u015fma.",
    "Error: No form element found.": "X\u0259ta: He\xe7 bir forma elementi tap\u0131lmad\u0131.",
    "Extended Latin": "Geni\u015fl\u0259ndirilmi\u015f Lat\u0131n",
    "Failed to initialize plugin: {0}": "Qo\u015fman\u0131 i\u015f\u0259 salmaq al\u0131nmad\u0131: {0}",
    "Failed to load plugin url: {0}": "Qo\u015fma url-i y\xfckl\u0259nm\u0259di: {0}",
    "Failed to load plugin: {0} from url {1}": "Qo\u015fma y\xfckl\u0259nm\u0259di: {0} urldan {1}",
    "Failed to upload image: {0}": "\u015e\u0259kil y\xfckl\u0259nm\u0259di: {0}",
    "File": "Fayl",
    "Find": "Tap",
    "Find (if searchreplace plugin activated)": "Tap (\u0259g\u0259r axtar\u0131\u015f \u0259lav\u0259si aktivdirs\u0259)",
    "Find and Replace": "Tap v\u0259 d\u0259yi\u015fdir",
    "Find and replace...": "Tap\u0131n v\u0259 d\u0259yi\u015fdirin",
    "Find in selection": "Se\xe7imd\u0259 tap",
    "Find whole words only": "Yaln\u0131z b\xfct\xf6v s\xf6zl\u0259ri tap\u0131n",
    "Flags": "Bayraqlar",
    "Focus to contextual toolbar": "Kontekst menyuya diqq\u0259t et",
    "Focus to element path": "Elementin m\u0259nb\u0259yin\u0259 diqq\u0259t et",
    "Focus to menubar": "Menyu \xe7ubu\u011funa diqq\u0259t et",
    "Focus to toolbar": "Al\u0259tl\u0259r \xe7ubu\u011funa diqq\u0259t et",
    "Font": "\u015erift",
    "Font size {0}": "M\u0259tn \xf6l\xe7\xfcs\xfc",
    "Font sizes": "\u015erift \xf6l\xe7\xfcl\u0259ri",
    "Font {0}": "\u015erift {0}",
    "Fonts": "Fontlar",
    "Food and Drink": "Yem\u0259k v\u0259 i\xe7ki",
    "Footer": "\u018fn a\u015fa\u011f\u0131",
    "Format": "Format",
    "Format {0}": "Format {0}",
    "Formats": "Formatlar",
    "Fullscreen": "Tam ekran rejimi",
    "G": "G",
    "General": "\xdcmumi",
    "Gray": "Boz",
    "Green": "Ya\u015f\u0131l",
    "Green component": "Ya\u015f\u0131l komponent",
    "Groove": "\xc7uxurlu",
    "Handy Shortcuts": "Laz\u0131ml\u0131 q\u0131sayollar",
    "Header": "Ba\u015fl\u0131q",
    "Header cell": "H\xfccr\u0259nin ba\u015fl\u0131\u011f\u0131",
    "Heading 1": "Ba\u015fl\u0131q 1",
    "Heading 2": "Ba\u015fl\u0131q 2",
    "Heading 3": "Ba\u015fl\u0131q 3",
    "Heading 4": "Ba\u015fl\u0131q 4",
    "Heading 5": "Ba\u015fl\u0131q 5",
    "Heading 6": "Ba\u015fl\u0131q 6",
    "Headings": "Ba\u015fl\u0131qlar",
    "Height": "H\xfcnd\xfcrl\xfcy\xfc",
    "Help": "K\xf6m\u0259k",
    "Hex color code": "Hex r\u0259ng kodu",
    "Hidden": "Gizli",
    "Horizontal align": "\xdcf\xfcqi d\xfczl\u0259ndirm\u0259",
    "Horizontal line": "Horizontal x\u0259tt",
    "Horizontal space": "Horizontal sah\u0259",
    "ID": "\u0130D",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "\u0130D h\u0259rfl\u0259 ba\u015flamal\u0131, ondan sonra yaln\u0131z h\u0259rfl\u0259r, r\u0259q\u0259ml\u0259r, tire, n\xf6qt\u0259, iki n\xf6qt\u0259 v\u0259 ya alt x\u0259tt olmal\u0131d\u0131r.",
    "Image is decorative": "T\u0259svir dekorativdir",
    "Image list": "\u015e\u0259kil listi",
    "Image title": "\u015e\u0259kil ba\u015fl\u0131\u011f\u0131",
    "Image...": "\u015e\u0259kil",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP x\u0259tas\u0131: \u015e\u0259kil Proksisini tapmaq m\xfcmk\xfcn olmad\u0131",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP x\u0259tas\u0131: Yanl\u0131\u015f \u015e\u0259kil Proksi URL-i",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP x\u0259tas\u0131: R\u0259dd edilmi\u015f sor\u011fu",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP x\u0259tas\u0131: Nam\u0259lum ImageProxy x\u0259tas\u0131",
    "Increase indent": "Bo\u015flu\u011fu art\u0131r",
    "Inline": "S\u0259tir i\xe7i",
    "Insert": "\u018flav\u0259 et",
    "Insert Template": "\u015eablon daxil et",
    "Insert accordion": "Akkordiona \u0259lav\u0259 edin",
    "Insert column after": "\u018fvv\u0259lin\u0259 s\xfctun \u0259lav\u0259 et",
    "Insert column before": "\u018fvv\u0259lin\u0259 s\u0259tir \u0259lav\u0259 et",
    "Insert date/time": "G\xfcn/tarix \u0259lav\u0259 et",
    "Insert image": "\u015e\u0259kil yerl\u0259\u015fdir",
    "Insert link (if link plugin activated)": "Link \u0259lav\u0259 et (\u0259g\u0259r link \u0259lav\u0259si aktivdirs\u0259)",
    "Insert row after": "Sonras\u0131na s\u0259tir \u0259lav\u0259 et",
    "Insert row before": "\u018fvv\u0259lin\u0259 s\u0259tir \u0259lav\u0259 et",
    "Insert table": "S\u0259tir \u0259lav\u0259 et",
    "Insert template...": "\u015eablon daxil edin",
    "Insert video": "Videonun \u0259lav\u0259 edilm\u0259si",
    "Insert/Edit code sample": "Kod n\xfcmun\u0259sin\u0259 \u0259lav\u0259/d\xfcz\u0259li\u015f et",
    "Insert/edit image": "\u015e\u0259kilin \u0259lav\u0259/redakt\u0259 edilm\u0259si",
    "Insert/edit link": "Linkin \u0259lav\u0259/redakt\u0259 edilm\u0259si",
    "Insert/edit media": "Media \u0259lav\u0259/d\xfcz\u0259li\u015f et",
    "Insert/edit video": "Videonun \u0259lav\u0259/redakt\u0259 edilm\u0259si",
    "Inset": "\u0130\xe7",
    "Invalid hex color code: {0}": "Yanl\u0131\u015f hex r\u0259ng kodu: {0}",
    "Invalid input": "Yaln\u0131\u015f daxiletm\u0259",
    "Italic": "Maili",
    "Justify": "H\u0259r iki t\u0259r\u0259f \xfczr\u0259",
    "Keyboard Navigation": "Klaviatura naviqasiyas\u0131",
    "Language": "Dil",
    "Learn more...": "Daha \xe7ox \xf6yr\u0259n...",
    "Left": "Sol t\u0259r\u0259f \xfczr\u0259",
    "Left to right": "Soldan sa\u011fa",
    "Light Blue": "A\xe7\u0131q mavi",
    "Light Gray": "A\xe7\u0131q boz",
    "Light Green": "A\xe7\u0131q ya\u015f\u0131l",
    "Light Purple": "A\xe7\u0131q b\u0259n\xf6v\u015f\u0259yi",
    "Light Red": "A\xe7\u0131q q\u0131rm\u0131z\u0131",
    "Light Yellow": "A\xe7\u0131q sar\u0131",
    "Line height": "S\u0259tir h\xfcnd\xfcrl\xfcy\xfc",
    "Link list": "Ke\xe7id listi",
    "Link...": "Ba\u011flant\u0131",
    "List Properties": "Siyah\u0131 x\xfcsusiyy\u0259tl\u0259ri",
    "List properties...": "Siyah\u0131 x\xfcsusiyy\u0259tl\u0259ri...",
    "Loading emojis...": "Emojil\u0259r y\xfckl\u0259nir...",
    "Loading...": "Y\xfckl\u0259nir...",
    "Lower Alpha": "Ki\xe7ik Alfa \u0259lifbas\u0131",
    "Lower Greek": "Ki\xe7ik Yunan \u0259lifbas\u0131",
    "Lower Roman": "Ki\xe7ik Roma \u0259lifbas\u0131",
    "Match case": "Registri n\u0259z\u0259r\u0259 al",
    "Mathematical": "Riyazi",
    "Media poster (Image URL)": "Media afi\u015fas\u0131 (\u015e\u0259kil URL)",
    "Media...": "Media",
    "Medium Blue": "Orta mavi",
    "Medium Gray": "Orta boz",
    "Medium Purple": "Orta b\u0259n\xf6v\u015f\u0259yi",
    "Merge cells": "H\xfccr\u0259l\u0259ri birl\u0259\u015ftir",
    "Middle": "Orta",
    "Midnight Blue": "Gec\u0259 mavisi",
    "More...": "Daha \xe7ox...",
    "Name": "Ad",
    "Navy Blue": "T\xfcnd g\xf6y",
    "New document": "Yeni s\u0259n\u0259d",
    "New window": "Yeni p\u0259nc\u0259r\u0259d\u0259 a\xe7\u0131ls\u0131n",
    "Next": "N\xf6vb\u0259ti",
    "No": "Xeyr",
    "No alignment": "Yerl\u0259\u015fdirm\u0259siz",
    "No color": "R\u0259ngsiz",
    "Nonbreaking space": "Q\u0131r\u0131lmaz sah\u0259",
    "None": "Yoxdur",
    "Numbered list": "N\xf6mr\u0259l\u0259nmi\u015f siyah\u0131",
    "OR": "V\u018f YA",
    "Objects": "\u018f\u015fyalar",
    "Ok": "Oldu",
    "Open help dialog": "K\xf6m\u0259k p\u0259nc\u0259r\u0259sini a\xe7",
    "Open link": "Ke\xe7idi a\xe7",
    "Open link in...": "Ba\u011flant\u0131y\u0131 a\xe7\u0131n",
    "Open popup menu for split buttons": "B\xf6lm\u0259 d\xfcym\u0259l\u0259ri \xfc\xe7\xfcn a\xe7\u0131lan menyunu a\xe7\u0131n",
    "Orange": "Nar\u0131nc\u0131",
    "Outset": "Xarici",
    "Page break": "S\u0259hif\u0259nin q\u0131r\u0131lmas\u0131",
    "Paragraph": "Paraqraf",
    "Paste": "Yazd\u0131r",
    "Paste as text": "M\u0259tn kimi \u0259lav\u0259 et",
    "Paste column after": "S\xfctundan sonra yap\u0131\u015fd\u0131r",
    "Paste column before": "S\xfctundan \u0259vv\u0259l yap\u0131\u015fd\u0131r",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Hal-haz\u0131rda adi m\u0259tn rejimind\u0259 yerl\u0259\u015fdirilir. M\u0259zmun sad\u0259 m\u0259tn \u015f\u0259klind\u0259 yerl\u0259\u015fdiril\u0259c\u0259k, h\u0259l\u0259 bu se\xe7imi d\u0259yi\u015fdirm\u0259.",
    "Paste or type a link": "Ke\xe7idi yerl\u0259\u015fdirin v\u0259 ya yaz\u0131n",
    "Paste row after": "Sonras\u0131na s\u0259tir \u0259lav\u0259 et",
    "Paste row before": "\u018fvv\u0259lin\u0259 s\u0259tir \u0259lav\u0259 et",
    "Paste your embed code below:": "\xd6z kodunuzu a\u015fa\u011f\u0131 \u0259lav\u0259 edin:",
    "People": "\u0130nsanlar",
    "Plugins": "\u018flav\u0259l\u0259r",
    "Plugins installed ({0}):": "\u018flav\u0259l\u0259r y\xfckl\u0259ndi ({0}):",
    "Powered by {0}": "{0} t\u0259r\u0259find\u0259n t\u0259chiz edilib",
    "Pre": "\xd6n",
    "Preferences": "T\u0259nziml\u0259m\u0259l\u0259r",
    "Preformatted": "\u018fvv\u0259lc\u0259d\u0259n formatland\u0131r\u0131lm\u0131\u015f",
    "Premium plugins:": "Premium \u0259lav\u0259l\u0259r",
    "Press the Up and Down arrow keys to resize the editor.": "Yuxar\u0131 v\u0259 a\u015fa\u011f\u0131 d\xfcym\u0259y\u0259 basaraq redaktorun \xf6l\xe7\xfcs\xfcn\xfc d\u0259yi\u015fin.",
    "Press the arrow keys to resize the editor.": "Ox i\u015far\u0259l\u0259rin\u0259 basaraq redaktorunuzu yenid\u0259n \xf6l\xe7\xfcl\u0259ndirin.",
    "Press {0} for help": "K\xf6m\u0259k \xfc\xe7\xfcn {0} bas\u0131n",
    "Preview": "\u0130lkinbax\u0131\u015f",
    "Previous": "\u018fvv\u0259lki",
    "Print": "\xc7ap",
    "Print...": "\xc7ap et",
    "Purple": "B\u0259n\xf6v\u015f\u0259yi",
    "Quotations": "T\u0259klifl\u0259r",
    "R": "R",
    "Range 0 to 255": "0-dan 255-\u0259 q\u0259d\u0259r diapazon",
    "Red": "Q\u0131rm\u0131z\u0131",
    "Red component": "Q\u0131rm\u0131z\u0131 komponent",
    "Redo": "\u0130r\u0259li",
    "Remove": "Sil",
    "Remove color": "R\u0259ngi silin",
    "Remove link": "Linki sil",
    "Replace": "D\u0259yi\u015fdir",
    "Replace all": "Ham\u0131s\u0131n\u0131 d\u0259yi\u015fdir",
    "Replace with": "Bununla d\u0259yi\u015fdir",
    "Resize": "\xd6l\xe7\xfcl\u0259ri d\u0259yi\u015f",
    "Restore last draft": "Son layih\u0259nin b\u0259rpas\u0131",
    "Reveal or hide additional toolbar items": "\u0130\xe7 panelinin \u0259\u015fyalar\u0131n\u0131 g\xf6st\u0259rin v\u0259 ya gizl\u0259din",
    "Rich Text Area": "Z\u0259ngin m\u0259tn redaktoru",
    "Rich Text Area. Press ALT-0 for help.": "Z\u0259ngin M\u0259tn Sah\u0259si. Yard\u0131m \xfc\xe7\xfcn ALT-0 d\xfcym\u0259sin\u0259 bas\u0131n.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "B\xf6y\xfck m\u0259tn sah\u0259si \u0259lav\u0259 edilib. Menyu \xfc\xe7\xfcn ALT-F9 d\xfcym\u0259sini bas\u0131n. Al\u0259tl\u0259r paneli \xfc\xe7\xfcn ALT-F10 d\xfcym\u0259sini bas\u0131n. K\xf6m\u0259k \xfc\xe7\xfcn ALT-0 d\xfcym\u0259l\u0259rin bas\u0131n.",
    "Ridge": "U\xe7urum",
    "Right": "Sa\u011f t\u0259r\u0259f \xfczr\u0259",
    "Right to left": "Sa\u011fdan sola",
    "Row": "S\u0259tir",
    "Row clipboard actions": "S\u0259tir m\xfcbadil\u0259 buferi h\u0259r\u0259k\u0259tl\u0259ri",
    "Row group": "S\u0259tirin qrupu",
    "Row header": "S\u0259tir ba\u015fl\u0131\u011f\u0131",
    "Row properties": "S\u0259trin x\xfcsusiyy\u0259tl\u0259ri",
    "Row type": "S\u0259tirin tipi",
    "Rows": "S\u0259tirl\u0259r",
    "Save": "Yadda saxla",
    "Save (if save plugin activated)": "Yadda\u015fa yaz (\u0259g\u0259r yadda\u015fa yaz \u0259lav\u0259si aktivdirs\u0259)",
    "Scope": "Sfera",
    "Search": "Axtar",
    "Select all": "H\u0259r birini se\xe7",
    "Select...": "Se\xe7...",
    "Selection": "Se\xe7im",
    "Shortcut": "Q\u0131sayol",
    "Show blocks": "Bloklar\u0131 g\xf6st\u0259r",
    "Show caption": "Ba\u015fl\u0131\u011f\u0131 g\xf6st\u0259r",
    "Show invisible characters": "G\xf6r\xfcnm\u0259y\u0259n simvollar\u0131 g\xf6st\u0259r",
    "Size": "\xd6l\xe7\xfc",
    "Solid": "Qat\u0131",
    "Source": "M\u0259nb\u0259",
    "Source code": "M\u0259nb\u0259 kodu",
    "Special Character": "X\xfcsusi simvol",
    "Special character...": "X\xfcsusi simvol",
    "Split cell": "H\xfccr\u0259l\u0259rin say\u0131",
    "Square": "Sah\u0259",
    "Start list at number": "Siyahinizi n\xf6mr\u0259l\u0259r il\u0259 ba\u015flay\u0131n",
    "Strikethrough": "\xdcst\xfcnd\u0259n x\u0259tt",
    "Style": "Stil",
    "Subscript": "A\u015fa\u011f\u0131 indeks",
    "Superscript": "Yuxar\u0131 indeks",
    "Switch to or from fullscreen mode": "Tam ekran rejimin ke\xe7in v\u0259 ya \xe7\u0131x\u0131n",
    "Symbols": "Simvollar",
    "System Font": "Sistem Fontu",
    "Table": "C\u0259dv\u0259l",
    "Table caption": "C\u0259dv\u0259l ba\u015fl\u0131\u011f\u0131",
    "Table properties": "C\u0259dv\u0259lin x\xfcsusiyy\u0259tl\u0259ri",
    "Table styles": "C\u0259dv\u0259l still\u0259ri",
    "Template": "\u015eablon",
    "Templates": "\u015eablonlar",
    "Text": "M\u0259tn",
    "Text color": "M\u0259tnin r\u0259ngi",
    "Text color {0}": "M\u0259tn r\u0259ngi {0}",
    "Text to display": "G\xf6r\xfcn\u0259n yaz\u0131n\u0131n t\u0259sviri",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Daxil etdiyiniz URL bir e-mail kimi g\xf6r\xfcn\xfcr. \u018fg\u0259r t\u0259l\u0259b olunan mailto: prefix \u0259lav\u0259 etm\u0259k ist\u0259yirsiniz?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Daxil etdiyiniz URL bir e-mail kimi g\xf6r\xfcn\xfcr. \u018fg\u0259r t\u0259l\u0259b olunan mailto: prefix \u0259lav\u0259 etm\u0259k ist\u0259yirsiniz?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Yazd\u0131\u011f\u0131n\u0131z URL linki xarici linkdir. https:// g\u0259r\u0259k\xe7\u0259sini \u0259lav\u0259 ed\u0259kmi?",
    "Title": "Ba\u015fl\u0131q",
    "To open the popup, press Shift+Enter": "A\xe7\u0131lan p\u0259nc\u0259r\u0259ni a\xe7maq \xfc\xe7\xfcn Shift + Enter d\xfcym\u0259l\u0259rini bas\u0131n",
    "Toggle accordion": "Akkordionu a\xe7\u0131n",
    "Tools": "Al\u0259tl\u0259r",
    "Top": "Yuxar\u0131",
    "Travel and Places": "S\u0259yah\u0259t v\u0259 m\u0259kanlar",
    "Turquoise": "Firuz\u0259yi",
    "Underline": "Alt x\u0259ttli",
    "Undo": "Geri",
    "Upload": "Y\xfckl\u0259",
    "Uploading image": "\u015e\u0259kil y\xfckl\u0259m\u0259",
    "Upper Alpha": "B\xf6y\xfck Alfa \u0259lifbas\u0131",
    "Upper Roman": "B\xf6y\xfck Roma \u0259lifbas\u0131",
    "Url": "Linkin \xfcnvan\u0131",
    "User Defined": "M\xfc\u0259yy\u0259n edilmi\u015f istifad\u0259\xe7i",
    "Valid": "Etibarl\u0131d\u0131r",
    "Version": "Versiya",
    "Vertical align": "\u015eaquli d\xfczl\u0259ndirm\u0259",
    "Vertical space": "Vertikal sah\u0259",
    "View": "G\xf6r\xfcn\xfc\u015f",
    "Visual aids": "Konturlar\u0131 g\xf6st\u0259r",
    "Warn": "X\u0259b\u0259rdar et",
    "White": "A\u011f",
    "Width": "Eni",
    "Word count": "S\xf6z say\u0131",
    "Words": "S\xf6zl\u0259r",
    "Words: {0}": "S\xf6zl\u0259r: {0}",
    "Yellow": "Sar\u0131",
    "Yes": "B\u0259li",
    "You are using {0}": "Siz {0} istifad\u0259 edirsiniz",
    "You have unsaved changes are you sure you want to navigate away?": "Sizd\u0259 yadda saxlan\u0131lmayan d\u0259yi\u015fiklikl\u0259r var \u0259minsiniz ki, getm\u0259k ist\u0259yirsiniz?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Sizin brauzeriniz m\xfcbadil\u0259 buferin\u0259 birba\u015fa yolu d\u0259st\u0259kl\u0259mir. Z\u0259hm\u0259t olmasa, bunun yerin\u0259 klaviaturan\u0131n Ctrl+X/C/V d\xfcym\u0259l\u0259rind\u0259n istifad\u0259 edin.",
    "alignment": "d\xfczl\u0259ndirm\u0259",
    "austral sign": "avstral simvolu",
    "cedi sign": "sedi simvolu",
    "colon sign": "qo\u015fa n\xf6qt\u0259",
    "cruzeiro sign": "cruzeiro i\u015far\u0259si",
    "currency sign": "valyuta i\u015far\u0259si",
    "dollar sign": "dollar i\u015far\u0259si",
    "dong sign": "donq simvolu",
    "drachma sign": "draxma simolu",
    "euro-currency sign": "avro-valyuta simvolu",
    "example": "n\xfcmun\u0259",
    "formatting": "formatla\u015fd\u0131rma",
    "french franc sign": "frans\u0131z frank\u0131 i\u015far\u0259si",
    "german penny symbol": "alman funt sterlinqi simvolu",
    "guarani sign": "guarani simvolu",
    "history": "tarix\xe7\u0259",
    "hryvnia sign": "qrivna simvolu",
    "indentation": "girinti",
    "indian rupee sign": "hindistan rupisi simvolu",
    "kip sign": "kip simvolu",
    "lira sign": "lir\u0259 simvolu",
    "livre tournois sign": "tur livri simvolu",
    "manat sign": "manat simvolu",
    "mill sign": "mil simvolu",
    "naira sign": "nayra simvolu",
    "new sheqel sign": "yeni \u015fekel simvolu",
    "nordic mark sign": "skandinav mark\u0131 simvolu",
    "peseta sign": "peseta simvolu",
    "peso sign": "peso simvolu",
    "ruble sign": "rubl simvolu",
    "rupee sign": "rupi simvolu",
    "spesmilo sign": "spesmilo simvolu",
    "styles": "still\u0259r",
    "tenge sign": "tenqe simvolu",
    "tugrik sign": "tuqrik simvolu",
    "turkish lira sign": "t\xfcrkiy\u0259 lir\u0259si simvolu",
    "won sign": "von simvolu",
    "yen character": "ye simvolu",
    "yen/yuan character variant one": "yen/yuan simvolu variant\u0131",
    "yuan character": "yuan simvolu",
    "yuan character, in hong kong and taiwan": "yuan simvolu, Hong Kong v\u0259 Tayvanda",
    "{0} characters": "{0} simvol",
    "{0} columns, {1} rows": "{0} s\xfctunlar, {1} s\u0131ralar",
    "{0} words": "{0} s\xf6z"
});